// Layout.jsx
import React from "react";
import Navbar from "./ui/Navbar";
import Footer from "./ui/Footer";
import { Helmet } from "react-helmet";
import { useTheme } from "../context/ThemeContext";

const Layout = ({ children }) => {
  const { theme } = useTheme();
  const canonicalUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <div className={`min-h-screen flex flex-col theme-${theme}`}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
